export const FETCH_LANGUAGE_START = 'FETCH_LANGUAGE_START';
export const FETCH_LANGUAGE_SUCCESS = 'FETCH_LANGUAGE_SUCCESS';
export const FETCH_LANGUAGE_FAIL = 'FETCH_LANGUAGE_FAIL';

export const FETCH_EVENT_LANGUAGE_START = 'FETCH_EVENT_LANGUAGE_START';
export const FETCH_EVENT_LANGUAGE_SUCCESS = 'FETCH_EVENT_LANGUAGE_SUCCESS';
export const FETCH_EVENT_LANGUAGE_FAIL = 'FETCH_EVENT_LANGUAGE_FAIL';

export const FETCH_LANGUAGES_START = 'FETCH_LANGUAGES_START';
export const FETCH_LANGUAGES_SUCCESS = 'FETCH_LANGUAGES_SUCCESS';
export const FETCH_LANGUAGES_FAIL = 'FETCH_LANGUAGES_FAIL';

export const FETCH_CERTIFICATE_LANGUAGES_START =
  'FETCH_CERTIFICATE_LANGUAGES_START';
export const FETCH_CERTIFICATE_LANGUAGES_SUCCESS =
  'FETCH_CERTIFICATE_LANGUAGES_SUCCESS';
export const FETCH_CERTIFICATE_LANGUAGES_FAIL =
  'FETCH_CERTIFICATE_LANGUAGES_FAIL';

export type LanguageActionTypes =
  | typeof FETCH_LANGUAGE_START
  | typeof FETCH_LANGUAGE_SUCCESS
  | typeof FETCH_LANGUAGE_FAIL
  | typeof FETCH_EVENT_LANGUAGE_START
  | typeof FETCH_EVENT_LANGUAGE_SUCCESS
  | typeof FETCH_EVENT_LANGUAGE_FAIL
  | typeof FETCH_LANGUAGES_START
  | typeof FETCH_LANGUAGES_SUCCESS
  | typeof FETCH_LANGUAGES_FAIL
  | typeof FETCH_CERTIFICATE_LANGUAGES_START
  | typeof FETCH_CERTIFICATE_LANGUAGES_SUCCESS
  | typeof FETCH_CERTIFICATE_LANGUAGES_FAIL;
